import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    meta: {
      title: "首页",
      icon: "home",
    },
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: {
          title: "首页",
          icon: "dashboard",
        },
      },
    ],
  },
];

export const asyncRouterMap = [
  {
    path: "/dashboard",
    component: Layout,
    redirect: "/dashboard/index",
    name: "dashboard",
    meta: {
      title: "数据看板",
      icon: "dashboard",
    },
    children: [
      {
        path: "index",
        name: "dashboardIndex",
        component: () => import("@/views/dashboard/index"),
        meta: {
          title: "数据看板",
          icon: "dashboard",
        },
      },
    ],
  },
  {
    path: "/merchat",
    component: Layout,
    redirect: "/merchat/merchat",
    name: "merchat",
    meta: {
      title: "店铺管理",
      icon: "shop",
    },
    children: [
      {
        path: "merchat",
        name: "merchat",
        component: () => import("@/views/merchat/merchat/index"),
        meta: {
          title: "店铺列表",
          icon: "product-list",
        },
      },
      {
        path: "detail",
        name: "detail",
        component: () => import("@/views/merchat/merchat/detail"),
        meta: {
          title: "店铺详情",
          icon: "product-list",
        },
        hidden: true,
      },
    ],
  },

  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: {
      title: "商品",
      icon: "product",
    },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: {
          title: "商品列表",
          icon: "product-list",
        },
      },

      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: {
          title: "添加商品",
          icon: "product-add",
        },
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: {
          title: "修改商品",
          icon: "product-add",
        },
        hidden: true,
      },
      {
        path: "checkProduct",
        name: "checkProduct",
        component: () => import("@/views/pms/product/check"),
        meta: {
          title: "查看商品",
          icon: "product-check",
        },
        hidden: true,
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: {
          title: "商品分类",
          icon: "product-cate",
        },
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: {
          title: "添加商品分类",
        },
        hidden: true,
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: {
          title: "修改商品分类",
        },
        hidden: true,
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: {
          title: "商品类型",
          icon: "product-attr",
        },
      },
      {
        path: "live",
        name: "live",
        component: () => import("@/views/pms/live/index"),
        meta: {
          title: "直播商品列表",
          icon: "product-brand",
        },
      },

      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: {
          title: "商品属性列表",
        },
        hidden: true,
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: {
          title: "添加商品属性",
        },
        hidden: true,
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: {
          title: "修改商品属性",
        },
        hidden: true,
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: {
          title: "品牌管理",
          icon: "product-brand",
        },
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: {
          title: "添加品牌",
        },
        hidden: true,
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: {
          title: "编辑品牌",
        },
        hidden: true,
      },
      {
        path: "userinfo",
        name: "userinfo",
        component: () => import("@/views/pms/userinfo/index"),
        meta: {
          title: "个人资料",
          icon: "user",
        },
        hidden: true,
      },
      {
        path: "warehouse",
        name: "warehouse",
        component: () => import("@/views/pms/warehouse/index"),
        meta: {
          title: "个人资料",
          icon: "user",
        },
        hidden: true,
      },
      {
        path: "productReview",
        name: "productReview",
        component: () => import("@/views/pms/review/index"),
        meta: {
          title: "商品审核列表",
          icon: "product-list",
        },
      },
    ],
  },

  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: {
      title: "订单",
      icon: "order",
    },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: {
          title: "订单列表",
          icon: "product-list",
        },
      },
      {
        path: "evaluate",
        name: "evaluate",
        component: () => import("@/views/oms/evaluate/index"),
        meta: {
          title: "评价管理",
          icon: "product-brand",
        },
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: {
          title: "订单详情",
        },
        hidden: true,
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/oms/order/deliverOrderList"),
        meta: {
          title: "发货列表",
        },
        hidden: true,
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: {
          title: "订单设置",
          icon: "order-setting",
        },
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: {
          title: "退货申请处理",
          icon: "order-return",
        },
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/oms/apply/reason"),
        meta: {
          title: "退货原因设置",
          icon: "order-return-reason",
        },
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/oms/apply/applyDetail"),
        meta: {
          title: "退货原因详情",
        },
        hidden: true,
      },
    ],
  },

  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/coupon",
    name: "sms",
    meta: {
      title: "营销",
      icon: "sms",
    },
    children: [
      {
        path: "coupon",
        name: "coupon",
        component: () => import("@/views/sms/coupon/index"),
        meta: {
          title: "优惠券列表",
          icon: "sms-coupon",
        },
      },
      {
        path: "flash",
        name: "flash",
        component: () => import("@/views/sms/flash/index"),
        meta: {
          title: "秒杀活动列表",
          icon: "sms-flash",
        },
      },
      {
        path: "flashSession",
        name: "flashSession",
        component: () => import("@/views/sms/flash/sessionList"),
        meta: {
          title: "秒杀时间段列表",
        },
        hidden: true,
      },
      {
        path: "selectSession",
        name: "selectSession",
        component: () => import("@/views/sms/flash/selectSessionList"),
        meta: {
          title: "秒杀时间段选择",
        },
        hidden: true,
      },
      {
        path: "flashProductRelation",
        name: "flashProductRelation",
        component: () => import("@/views/sms/flash/productRelationList"),
        meta: {
          title: "秒杀商品列表",
        },
        hidden: true,
      },

      {
        path: "addCoupon",
        name: "addCoupon",
        component: () => import("@/views/sms/coupon/add"),
        meta: {
          title: "添加优惠券",
        },
        hidden: true,
      },
      {
        path: "updateCoupon",
        name: "updateCoupon",
        component: () => import("@/views/sms/coupon/update"),
        meta: {
          title: "修改优惠券",
        },
        hidden: true,
      },
      {
        path: "calculateCoupon",
        name: "calculateCoupon",
        component: () => import("@/views/sms/coupon/calculate"),
        meta: {
          title: "计算优惠券金额",
        },
        hidden: true,
      },
      {
        path: "couponHistory",
        name: "couponHistory",
        component: () => import("@/views/sms/coupon/history"),
        meta: {
          title: "优惠券领取详情",
        },
        hidden: true,
      },
      {
        path: "brand",
        name: "homeBrand",
        component: () => import("@/views/sms/brand/index"),
        meta: {
          title: "品牌推荐",
          icon: "product-brand",
        },
      },
      {
        path: "new",
        name: "homeNew",
        component: () => import("@/views/sms/new/index"),
        meta: {
          title: "新品推荐",
          icon: "sms-new",
        },
      },
      {
        path: "hot",
        name: "homeHot",
        component: () => import("@/views/sms/hot/index"),
        meta: {
          title: "人气推荐",
          icon: "sms-hot",
        },
      },
      {
        path: "subject",
        name: "homeSubject",
        component: () => import("@/views/sms/subject/index"),
        meta: {
          title: "专题推荐",
          icon: "sms-subject",
        },
      },
      {
        path: "advertise",
        name: "homeAdvertise",
        component: () => import("@/views/sms/advertise/index"),
        meta: {
          title: "广告列表",
          icon: "sms-ad",
        },
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/sms/advertise/add"),
        meta: {
          title: "添加广告",
        },
        hidden: true,
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/sms/advertise/update"),
        meta: {
          title: "编辑广告",
        },
        hidden: true,
      },
    ],
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: {
      title: "权限",
      icon: "ums",
    },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: {
          title: "管理用户列表",
          icon: "ums-admin",
        },
      },
      {
        path: "member",
        name: "member",
        component: () => import("@/views/ums/member/index"),
        meta: {
          title: "用户列表",
          icon: "ums-admin",
        },
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: {
          title: "角色列表",
          icon: "ums-role",
        },
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: {
          title: "分配菜单",
        },
        hidden: true,
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: {
          title: "分配资源",
        },
        hidden: true,
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: {
          title: "菜单列表",
          icon: "ums-menu",
        },
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: {
          title: "添加菜单",
        },
        hidden: true,
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: {
          title: "修改菜单",
        },
        hidden: true,
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: {
          title: "资源列表",
          icon: "ums-resource",
        },
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: {
          title: "资源分类",
        },
        hidden: true,
      },
      {
        path: "version",
        name: "version",
        component: () => import("@/views/ums/version/index"),
        meta: {
          title: "版本管理",
        },
      },
      {
        path: "dict",
        name: "dict",
        component: () => import("@/views/ums/dict/index"),
        meta: {
          title: "字典管理",
        },
      },
      {
        path: "config",
        name: "config",
        component: () => import("@/views/ums/config/index"),
        meta: {
          title: "系统配置",
        },
      },
    ],
  },
  {
    path: "/finance",
    component: Layout,
    redirect: "/finance/statistics",
    name: "finance",
    meta: {
      title: "财务管理",
      icon: "shop",
    },
    children: [
      {
        path: "statistics",
        name: "statistics",
        component: () => import("@/views/finance/statistics/index"),
        meta: {
          title: "统计",
          icon: "statistics",
        },
      },
      {
        path: "funds",
        name: "funds",
        component: () => import("@/views/finance/funds/index"),
        meta: {
          title: "账户中心",
          icon: "product-cate",
        },
      },
      {
        path: "edit",
        name: "edit",
        component: () => import("@/views/finance/funds/edit"),
        meta: {
          title: "绑定银行卡",
          icon: "product-cate",
        },
        hidden: true,
      },
      {
        path: "withdrawAudit",
        name: "withdrawAudit",
        component: () => import("@/views/finance/withdrawAudit/index"),
        meta: {
          title: "提现审核",
          icon: "product-cate",
        },
      },
      {
        path: "dashboard",
        name: "dashboardCate",
        component: () => import("@/views/finance/dashboard/index"),
        meta: {
          title: "账务仪表盘",
          icon: "product-cate",
        },
      },
    ],
  },
  {
    path: "/kefuManage",
    component: Layout,
    redirect: "/kefuManage/shopKefu",
    name: "kefuManage",
    meta: {
      title: "客服管理",
      icon: "shop",
    },
    children: [
      {
        path: "shopKefu",
        name: "shopKefu",
        component: () => import("@/views/kefuManage/shopKefu/index"),
        meta: {
          title: "店铺客服",
          icon: "kefu",
        },
      },
    ],
  },
  {
    path: "/feedBackManage",
    component: Layout,
    redirect: "/feedBackManage/feedBack",
    name: "feedBackManage",
    meta: {
      title: "反馈建议管理",
      icon: "shop",
    },
    children: [
      {
        path: "feedBack",
        name: "feedBack",
        component: () => import("@/views/feedBackManage/feedBack/index"),
        meta: {
          title: "反馈与建议记录",
          icon: "kefu",
        },
      },
      {
        path: "feedBackType",
        name: "feedBackType",
        component: () => import("@/views/feedBackManage/feedBackType/index"),
        meta: {
          title: "反馈与建议类型",
          icon: "kefu",
        },
      },
    ],
  },
  {
    path: "/subAccount",
    component: Layout,
    redirect: "/subAccount/list",
    name: "subAccount",
    meta: {
      title: "子账号管理",
      icon: "shop",
    },
    children: [
      {
        path: "list",
        name: "list",
        component: () => import("@/views/subAccount/index"),
        meta: {
          title: "子账号列表",
          icon: "shop",
        },
      },
    ],
  },
  {
    path: "/auditManage",
    component: Layout,
    redirect: "/auditManage/auditVideo",
    name: "auditManage",
    meta: {
      title: "审核管理",
      icon: "shop",
    },
    children: [
      {
        path: "videoAudit",
        name: "videoAudit",
        component: () => import("@/views/auditManage/videoAudit/index"),
        meta: {
          title: "短视频审核",
          icon: "kefu",
        },
      },
      {
        path: "videoReport",
        name: "videoReport",
        component: () => import("@/views/auditManage/videoReport/index"),
        meta: {
          title: "短视频举报",
          icon: "kefu",
        },
      },
      {
        path: "membeReport",
        name: "membeReport",
        component: () => import("@/views/auditManage/membeReport/index"),
        meta: {
          title: "人员举报",
          icon: "kefu",
        },
      },
      {
        path: "commentReport",
        name: "commentReport",
        component: () => import("@/views/auditManage/commentReport/index"),
        meta: {
          title: "评论举报",
          icon: "kefu",
        },
      },
      {
        path: "commentAudit",
        name: "commentAudit",
        component: () => import("@/views/auditManage/commentAudit/index"),
        meta: {
          title: "评论审核",
          icon: "kefu",
        },
      },
      {
        path: "contentAudit",
        name: "contentAudit",
        component: () => import("@/views/auditManage/contentAudit/index"),
        meta: {
          title: "内容审核",
          icon: "contentAudit",
        },
      },
    ],
  },
  {
    path: "/external",
    component: Layout,
    children: [
      {
        path: "",
        name: "external",
        component: () => import("@/views/external/index"),
        meta: {
          title: "导航页面",
          icon: "sms-ad",
          username: "admin",
        },
      },
    ],
  },

  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRouterMap,
});
